module.exports = __webpack_public_path__ + "static/media/pi.96b9c539.svg";